/**
 * Card Components
 *
 * Enhanced card components with rich media support and modern layouts.
 */

export { MediaCard, type MediaCardProps } from "./media-card";
export { QuoteCard, type QuoteCardProps } from "./quote-card";
